import { render, staticRenderFns } from "./TwoForOne.vue?vue&type=template&id=7b084406&"
import script from "./TwoForOne.vue?vue&type=script&lang=ts&"
export * from "./TwoForOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports